export class UnsupportedFormatError extends Error {
    format;
    name = 'UnsupportedFormatError';
    constructor(format) {
        super(`Unsupported format: ${format}`);
        this.format = format;
    }
}
export class ParseError extends Error {
    name = 'ParseError';
    constructor(message, cause) {
        super(message, cause === undefined ? undefined : { cause });
    }
}
//# sourceMappingURL=types.js.map